import * as v from 'valibot';

export const MaterialSchema = v.object({
  altText: v.nullish(v.string()),
  width: v.nullish(v.number()),
  height: v.nullish(v.number()),
  productId: v.nullish(v.string()),
  productVersion: v.nullish(v.number()),
  accessLink: v.nullish(v.string()),
  contentType: v.nullish(v.string()),
  webTitle: v.nullish(v.string()),
  productType: v.nullish(v.string()),
  crispReports: v.nullish(v.boolean()),
  crisp: v.nullish(v.boolean()),
  thumbnail: v.nullish(v.string()),
  webDescription: v.nullish(v.string()),
  webLocale: v.nullish(v.string()),
  customHtml: v.nullish(v.string()),
  downloadable: v.boolean(),
  scalable: v.nullish(v.boolean()),
  usable: v.nullish(v.boolean()),
  document: v.nullish(v.unknown()),
  // lti related properties
  iframe: v.nullish(
    v.object({
      src: v.nullish(v.string()),
      width: v.nullish(v.number()),
      height: v.nullish(v.number()),
    }),
  ),
  window: v.nullish(
    v.object({
      targetName: v.nullish(v.string()),
      width: v.nullish(v.number()),
      height: v.nullish(v.number()),
      windowFeatures: v.nullish(v.string()),
    }),
  ),
});

export type TMaterial = v.Output<typeof MaterialSchema>;
